<template>

<div class="panel" onboarding="panel">

	<com-marksheets :panel="panel.marksheets" :initTime="initTime" v-if="panel.marksheets" />
	<com-marksheet :panel="panel.marksheet" :initTime="initTime" v-if="panel.marksheet" />

</div>

</template>

<script>

import comMarksheets from './panel/Marksheets'
import comMarksheet from './panel/Marksheet'

export default {

	props: ['panel', 'initTime'],

	components: {
		'com-marksheets': comMarksheets,
		'com-marksheet': comMarksheet
	}

}

</script>

<style scoped>

.sidebar {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 256px;
	padding: 10px;
	bottom: 54px;
	display: flex;
	flex-direction: column;
	z-index: 2;
	transition: left 300ms ease-in-out;
}

.sidebar-logo {
	background-image: url(~@/assets/logo.png);
	background-position: 50% 50%;
	background-size: 210.5px 85px;
	background-repeat: no-repeat;
	height: 85px;
	flex-shrink: 0;
}

@media (max-height: 799px) {

	.sidebar-logo {
		display: none;
	}

}

.sidebar-user {
	position: relative!important;
	flex-shrink: 0!important;
	transition: none!important;
}

.sidebar-user >>> .stream {
	border-radius: 4px 4px 0px 0px;
	overflow: hidden;
}

.sidebar-user:not(.is-expanded) >>> .stream {
	height: 177px!important;
	border-radius: 4px 4px 0px 0px;
	overflow: hidden;
}

</style>
